import { Web3Provider } from '@ethersproject/providers'
import { InjectedConnector } from '@web3-react/injected-connector'
import { PortisConnector } from '@web3-react/portis-connector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { WalletLinkConnector } from '@web3-react/walletlink-connector'

import { FortmaticConnector } from './Fortmatic'
import { NetworkConnector } from './NetworkConnector'

const CHAIN_ID = process.env.REACT_APP_CHAIN_ID
const PORTIS_ID = process.env.REACT_APP_PORTIS_ID
const FORMATIC_KEY = process.env.REACT_APP_FORTMATIC_KEY
const NETWORK_PROVIDER = process.env.REACT_APP_NETWORK_PROVIDER
const PROVIDER_PROJECT_ID = process.env.REACT_APP_PROVIDER_PROJECT_ID

const PROVIDER_PROJECT_SECRET = process.env.REACT_APP_PROVIDER_PROJECT_SECRET || ''
const PROVIDER_NETWORK_ID = process.env.REACT_APP_PROVIDER_NETWORK_ID || 'mainnet'

// Public RPC endpoints for supported chains
const PUBLIC_RPC_URLS: { [chainId: number]: string } = {
  1: 'https://eth.drpc.org',
  56: 'https://bsc-dataseed.binance.org',
  97: 'https://data-seed-prebsc-1-s1.binance.org:8545',
  137: 'https://polygon-bor-rpc.publicnode.com',
  1285: 'https://rpc.api.moonriver.moonbeam.network',
  42161: 'https://arb1.arbitrum.io/rpc'
}

let networkUrl: string

if (PROVIDER_PROJECT_ID && PROVIDER_PROJECT_ID !== '') {
  // Use Infura if project ID is provided
  switch (NETWORK_PROVIDER) {
    case 'infura':
    default:
      networkUrl = `https://${PROVIDER_PROJECT_SECRET &&
        `:${PROVIDER_PROJECT_SECRET}@`}${PROVIDER_NETWORK_ID}.infura.io/v3/${PROVIDER_PROJECT_ID}`
      break
  }
} else {
  // Fall back to public RPC based on chain ID
  const chainId = parseInt(CHAIN_ID ?? '137')
  networkUrl = PUBLIC_RPC_URLS[chainId] || PUBLIC_RPC_URLS[137]
}

export const NETWORK_CHAIN_ID: number = parseInt(CHAIN_ID ?? '137')

if (typeof networkUrl === 'undefined') {
  throw new Error('REACT_APP_NETWORK_URL must be a defined environment variable')
}

export const network = new NetworkConnector({
  urls: { [NETWORK_CHAIN_ID]: networkUrl }
})

let networkLibrary: Web3Provider | undefined
export function getNetworkLibrary(): Web3Provider {
  return (networkLibrary = networkLibrary ?? new Web3Provider(network.provider as any))
}

// Support BSC Testnet only in staging
export const injected = new InjectedConnector({
  supportedChainIds:
    process.env.REACT_APP_ENVIRONMENT === 'production'
      ? [56, 137, 42161, 1285]
      : [1, 56, 97, 137, 42161, 1285]
})

// mainnet only
export const walletconnect = new WalletConnectConnector({
  bridge: 'https://bridge.walletconnect.org',
  // pollingInterval: 15000
  qrcode: true,
  rpc: { 1: networkUrl }
})

// mainnet only
export const fortmatic = new FortmaticConnector({
  apiKey: FORMATIC_KEY ?? '',
  chainId: 1
})

// mainnet only
export const portis = new PortisConnector({
  dAppId: PORTIS_ID ?? '',
  networks: [1]
})

// mainnet only
export const walletlink = new WalletLinkConnector({
  appLogoUrl: 'https://i.postimg.cc/RVRPM9sG/XATA.png',
  appName: 'XATA',
  url: networkUrl
})
